import api, { MainDomain } from "api";
import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router";
import "./attachments.scss";
import { useSelector } from "react-redux";
import { RootState } from "types";

function Attachments() {
  const params: any = useParams();
  const user = useSelector((state: RootState) => state.user);

  const [attachments, setAttachments] = useState([]);

  const handleOnPaste = (e: React.ClipboardEvent<HTMLElement>) => {
    const items = e.clipboardData.items;

    let blob = null;
    for (let i = 0; i < items.length; i++) {
      if (items[i].kind !== "string" && !items[i].type.match("^text/plain")) {
        blob = items[i].getAsFile();
      }
    }

    if (blob !== null) {
      api.ticket.attachment.add(params.ticketId, user.Id, blob).then(() => {
        getAttachments();
      });
    }
  };

  const getAttachments = useCallback(() => {
    if (params.ticketId) {
      api.ticket.attachment.getAll(params.ticketId).then((data) => {
        setAttachments(data);
      });
    }
  }, [params.ticketId]);

  const uploadAttachment = (file: File) => {
    api.ticket.attachment.add(params.ticketId, user.Id, file).then(() => {
      getAttachments();
    });
  };

  const removeAttachment = (id: number, e: any) => {
    e.preventDefault();
    setAttachments(attachments.filter((x: any) => x.Id !== id));
    api.ticket.attachment.remove(id, params.ticketId);
  };

  const getFileType = (fileName: string) => {
    if (fileName === "file") return;
    if (fileName.split(".")[1].includes("png")) return "image";
    if (fileName.split(".")[1].includes("jpg")) return "image";
    if (fileName.split(".")[1].includes("gif")) return "image";
    if (fileName.split(".")[1].includes("svg")) return "image";
    if (fileName.split(".")[1].includes("xls")) return "file";
    if (fileName.split(".")[1].includes("doc")) return "file";
    if (fileName.split(".")[1].includes("pdf")) return "file";
    if (fileName.split(".")[1].includes("csv")) return "file";
    return "video";
  };

  useEffect(() => {
    getAttachments();
  }, [getAttachments]);

  return (
    <div className="input-group attachments" onPaste={(e) => handleOnPaste(e)}>
      <label>Attachments</label>
      {attachments.map((x: any, i: number) => {
        if (getFileType(x.FileName) === "image") {
          return (
            // <a href={`https://workflow-api.amasocial.co.za/api/ticket/attachment/${x.Guid}`} target="_blank" rel="noreferrer" className="attachment image" key={i} style=
            // {{background: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(https://workflow-api.amasocial.co.za/api/ticket/attachment/${x.FileName})`}}>
            <a
              href={`https://workflow-api.${MainDomain}.co.za/api/ticket/attachment/${x.Guid}`}
              target="_blank"
              rel="noreferrer"
              className="attachment image"
              key={i}
              style={{
                background: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(https://workflow-api.${MainDomain}.co.za/api/ticket/attachment/${x.Guid})`,
              }}
            >
              <i
                className="fal fa-times"
                onClick={(e) => removeAttachment(x.Id, e)}
              ></i>
              <span
                title={x.FileName}
                style={{
                  color: "#FFF",
                  textShadow: "0 1px 3px rgba(0,0,0,0.4)",
                }}
              >
                {x.FileName}
              </span>
            </a>
          );
        } else if (getFileType(x.FileName) === "file") {
          return (
            // <a href={`https://workflow-api.amasocial.co.za/api/ticket/attachment/${x.Guid}`} className="attachment file" key={i}>
            <a
              href={`https://workflow-api.${MainDomain}.co.za/api/ticket/attachment/${x.Guid}`}
              className="attachment file"
              key={i}
            >
              <i className="fal fa-file-alt"></i>
              <i
                className="fal fa-times"
                onClick={(e) => removeAttachment(x.Id, e)}
              ></i>
              <span
                title={x.FileName}
                style={{
                  color: "#000",
                  textShadow: "0 1px 3px rgba(0,0,0,0.2)",
                }}
              >
                {x.FileName}
              </span>
            </a>
          );
        } else {
          return (
            // <a href={`https://workflow-api.amasocial.co.za/api/ticket/attachment/${x.Guid}`} target="_blank" rel="noreferrer" className="attachment video" key={i}>
            <a
              href={`https://workflow-api.${MainDomain}.co.za/api/ticket/attachment/${x.Guid}`}
              target="_blank"
              rel="noreferrer"
              className="attachment video"
              key={i}
            >
              <i className="fal fa-video"></i>
              <i
                className="fal fa-times"
                onClick={(e) => removeAttachment(x.Id, e)}
              ></i>
              <span
                title={x.FileName}
                style={{
                  color: "#000",
                  textShadow: "0 1px 3px rgba(0,0,0,0.2)",
                }}
              >
                {x.FileName}
              </span>
            </a>
          );
        }
      })}
      <div className="new-attachment">
        <label htmlFor="new-attachment">
          <i className="fal fa-upload"></i>
          Add Attachment
        </label>
        <input
          type="file"
          id="new-attachment"
          defaultValue=""
          onChange={(e) => uploadAttachment(e.currentTarget.files![0])}
        />
      </div>
    </div>
  );
}

export default Attachments;
